/**
 * ss-cats-slider.js — Shop by Category mobile one-card snap (mirrors ss-proof-slider)
 */
(function () {
  'use strict';

  var MQ = '(max-width: 749px)';

  function init(track) {
    if (!track || track.dataset.ssCatsInit) return;

    var cards = track.querySelectorAll('.ss-cats__card');
    if (cards.length < 2) return;
    if (!window.matchMedia(MQ).matches) return;

    track.dataset.ssCatsInit = '1';

    var index = 0;
    var wrap = track.closest('.ss-cats__mosaic-wrap') || track.parentElement;
    if (!wrap) return;

    var existing = wrap.querySelector('.ss-cats__dots');
    if (existing) existing.remove();

    var dotsWrap = document.createElement('div');
    dotsWrap.className = 'ss-cats__dots';
    dotsWrap.setAttribute('role', 'tablist');
    dotsWrap.setAttribute('aria-label', 'Categories');

    cards.forEach(function (_card, i) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'ss-cats__dot' + (i === 0 ? ' is-active' : '');
      dot.setAttribute('aria-label', 'Category ' + (i + 1));
      dot.addEventListener('click', function () { scrollToIndex(i); });
      dotsWrap.appendChild(dot);
    });
    wrap.appendChild(dotsWrap);

    function updateDots() {
      dotsWrap.querySelectorAll('.ss-cats__dot').forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
      });
    }

    function scrollToIndex(i) {
      index = (i + cards.length) % cards.length;
      var card = cards[index];
      if (!card) return;
      track.scrollTo({ left: card.offsetLeft, behavior: 'smooth' });
      updateDots();
    }

    track.addEventListener('scroll', function () {
      var left = track.scrollLeft;
      var closest = 0;
      var min = Infinity;
      cards.forEach(function (card, i) {
        var d = Math.abs(card.offsetLeft - left);
        if (d < min) {
          min = d;
          closest = i;
        }
      });
      if (closest !== index) {
        index = closest;
        updateDots();
      }
    }, { passive: true });
  }

  function boot() {
    document.querySelectorAll('[data-ss-cats-slider]').forEach(init);
  }

  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-ss-cats-slider]').forEach(function (track) {
      track.removeAttribute('data-ss-cats-init');
      init(track);
    });
  });
  window.addEventListener('resize', function () {
    document.querySelectorAll('[data-ss-cats-slider][data-ss-cats-init]').forEach(function (track) {
      track.removeAttribute('data-ss-cats-init');
      var wrap = track.closest('.ss-cats__mosaic-wrap') || track.parentElement;
      if (wrap) {
        var dots = wrap.querySelector('.ss-cats__dots');
        if (dots) dots.remove();
      }
    });
    boot();
  }, { passive: true });
})();
